import Vue from 'vue'
import Router from 'vue-router'
// hack router push callback
const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
    return originalPush.call(this, location).catch(err => err)
}
export default new Router({
    mode: 'hash',
    routes: [
        {
            path: '/',
            name: 'home',
            redirect: '/index'
        },
        {
            path: '/index',
            name: '首页',
            component: () => import('@/pages/index/index')
        },
        // 安友云联
        {
            path: '/ayyk',
            name: '/ayyk',
            component: () => import('@/pages/ayyk/index'),
        },
        // 人脸识别
        {
            path: '/ayyk/pageA',
            name: '/ayyk/pageA',
            component: () => import('@/pages/ayyk/pageA/index'),
        },
        {
            path: '/ayyk/pageA/product1',
            name: '/ayyk/pageA/product1',
            component: () => import('@/pages/ayyk/pageA/product1'),
        },
        {
            path: '/ayyk/pageA/product2',
            name: '/ayyk/pageA/product2',
            component: () => import('@/pages/ayyk/pageA/product2'),
        },
        {
            path: '/ayyk/pageA/product3',
            name: '/ayyk/pageA/product3',
            component: () => import('@/pages/ayyk/pageA/product3'),
        },
        {
            path: '/ayyk/pageA/product4',
            name: '/ayyk/pageA/product4',
            component: () => import('@/pages/ayyk/pageA/product4'),
        },
        {
            path: '/ayyk/pageA/product5',
            name: '/ayyk/pageA/product5',
            component: () => import('@/pages/ayyk/pageA/product5'),
        },

        // 人员管理
        {
            path: '/ayyk/pageB',
            name: '/ayyk/pageB',
            component: () => import('@/pages/ayyk/pageB/index'),
        },
        {
            path: '/ayyk/pageB/product1',
            name: '/ayyk/pageB/product1',
            component: () => import('@/pages/ayyk/pageB/product1'),
        },
        {
            path: '/ayyk/pageB/product2',
            name: '/ayyk/pageB/product2',
            component: () => import('@/pages/ayyk/pageB/product2'),
        },
        {
            path: '/ayyk/pageB/product3',
            name: '/ayyk/pageB/product3',
            component: () => import('@/pages/ayyk/pageB/product3'),
        },
        {
            path: '/ayyk/pageB/product4',
            name: '/ayyk/pageB/product4',
            component: () => import('@/pages/ayyk/pageB/product4'),
        },
        {
            path: '/ayyk/pageB/product5',
            name: '/ayyk/pageB/product5',
            component: () => import('@/pages/ayyk/pageB/product5'),
        },
        // 车辆管理
        {
            path: '/ayyk/pageC',
            name: '/ayyk/pageC',
            component: () => import('@/pages/ayyk/pageC/index'),
        },
        {
            path: '/ayyk/pageC/product1',
            name: '/ayyk/pageC/product1',
            component: () => import('@/pages/ayyk/pageC/product1'),
        },
        {
            path: '/ayyk/pageC/product2',
            name: '/ayyk/pageC/product2',
            component: () => import('@/pages/ayyk/pageC/product2'),
        },
        {
            path: '/ayyk/pageC/product3',
            name: '/ayyk/pageC/product3',
            component: () => import('@/pages/ayyk/pageC/product3'),
        },
        {
            path: '/ayyk/pageC/product4',
            name: '/ayyk/pageC/product4',
            component: () => import('@/pages/ayyk/pageC/product4'),
        },
        // 环境管理
        {
            path: '/ayyk/pageD',
            name: '/ayyk/pageD',
            component: () => import('@/pages/ayyk/pageD/index'),
        },
        {
            path: '/ayyk/pageD/product1',
            name: '/ayyk/pageD/product1',
            component: () => import('@/pages/ayyk/pageD/product1'),
        },
        {
            path: '/ayyk/pageD/product2',
            name: '/ayyk/pageD/product2',
            component: () => import('@/pages/ayyk/pageD/product2'),
        },
        {
            path: '/ayyk/pageD/product3',
            name: '/ayyk/pageD/product3',
            component: () => import('@/pages/ayyk/pageD/product3'),
        },
        {
            path: '/ayyk/pageD/product4',
            name: '/ayyk/pageD/product4',
            component: () => import('@/pages/ayyk/pageD/product4'),
        },
        {
            path: '/ayyk/pageD/product5',
            name: '/ayyk/pageD/product5',
            component: () => import('@/pages/ayyk/pageD/product5'),
        },
        // 现场管理
        {
            path: '/ayyk/pageE',
            name: '/ayyk/pageE',
            component: () => import('@/pages/ayyk/pageE/index'),
        },
        {
            path: '/ayyk/pageE/product1',
            name: '/ayyk/pageE/product1',
            component: () => import('@/pages/ayyk/pageE/product1'),
        },
        {
            path: '/ayyk/pageE/product2',
            name: '/ayyk/pageE/product2',
            component: () => import('@/pages/ayyk/pageE/product2'),
        },
        {
            path: '/ayyk/pageE/product3',
            name: '/ayyk/pageE/product3',
            component: () => import('@/pages/ayyk/pageE/product3'),
        },
        {
            path: '/ayyk/pageE/product4',
            name: '/ayyk/pageE/product4',
            component: () => import('@/pages/ayyk/pageE/product4'),
        },
        {
            path: '/ayyk/pageE/product5',
            name: '/ayyk/pageE/product5',
            component: () => import('@/pages/ayyk/pageE/product5'),
        },
        {
            path: '/ayyk/pageE/product6',
            name: '/ayyk/pageE/product6',
            component: () => import('@/pages/ayyk/pageE/product6'),
        },
        {
            path: '/ayyk/pageE/product7',
            name: '/ayyk/pageE/product7',
            component: () => import('@/pages/ayyk/pageE/product7'),
        },
        // 安友云联
        {
            path: '/ayyl',
            name: 'ayyl',
            component: () => import('@/pages/ayyl/index')
        },
        {
            path: '/ayyl/platform_1',
            name: 'ayyl/platform_1',
            component: () => import('@/pages/ayyl/platform_1')
        },
        {
            path: '/ayyl/platform_2',
            name: 'ayyl/platform_2',
            component: () => import('@/pages/ayyl/platform_2')
        },
        {
            path: '/ayyl/platform_3',
            name: 'ayyl/platform_3',
            component: () => import('@/pages/ayyl/platform_3')
        },
        {
            path: '/ayyl/platform_4',
            name: 'ayyl/platform_4',
            component: () => import('@/pages/ayyl/platform_4')
        },
        {
            path: '/ayyl/platform_5',
            name: 'ayyl/platform_5',
            component: () => import('@/pages/ayyl/platform_5')
        },
        {
            path: '/ayyl/platform_6',
            name: 'ayyl/platform_6',
            component: () => import('@/pages/ayyl/platform_6')
        },
        {
            path: '/ayyl/platform_7',
            name: 'ayyl/platform_7',
            component: () => import('@/pages/ayyl/platform_7')
        },
        {
            path: '/ayyl/platform_8',
            name: 'ayyl/platform_8',
            component: () => import('@/pages/ayyl/platform_8')
        },
        // 解决方案
        {
            path: '/jjfa/gcjs',
            name: 'jjfa/gcjs',
            component: () => import('@/pages/jjfa/gcjs/index')
        },
        {
            path: '/jjfa/yqgk',
            name: 'jjfa/yqgk',
            component: () => import('@/pages/jjfa/yqgk/index')
        },
        // 案例展示
        {
            path: '/alzs',
            name: 'alzs',
            component: () => import('@/pages/alzs/index')
        },
        {
            path: '/alzs/page/:index',
            name: 'alzs/page',
            component: () => import('@/pages/alzs/page')
        },
        {
            path: '/qdjs',
            name: 'qdjs',
            component: () => import('@/pages/qdjs/index')
        },


        

        {
            path: '/enterprise-solution',
            name: '企业端解决方案',
            component: () => import('@/pages/solution/enterprise-solution')
        },
        {
            path: '/project-solution',
            name: '项目端解决方案',
            component: () => import('@/pages/solution/project-solution')
        },
        {
            path: '/construction-solution',
            name: '安全施工解决方案',
            component: () => import('@/pages/solution/construction-solution')
        },
        {
            path: '/dangerou-solution',
            name: '危大工程解决方案',
            component: () => import('@/pages/solution/dangerou-solution')
        },
        {
            path: '/product',
            name: '产品中心',
            component: () => import('@/pages/product/index')
        },
        {
            path: '/cases',
            name: '经典案例',
            component: () => import('@/pages/cases/index')
        },
        {
            path: '/cases-detail',
            name: '房建项目',
            component: () => import('@/pages/cases/cases-detail')
        },
        {
            path: '/cases-detail-page1',
            name: '房建项目1',
            component: () => import('@/pages/cases/cases-detail-page1')
        },
        {
            path: '/municipal-detail',
            name: '市政项目',
            component: () => import('@/pages/cases/municipal-detail')
        },
        {
            path: '/qypt',
            name: '关于我们',
            component: () => import('@/pages/qypt/index')
        },
        {
            path: '/about',
            name: '关于我们',
            component: () => import('@/pages/about/index')
        },
        {
            path: '/call',
            name: '加入我们',
            component: () => import('@/pages/call/index')
        },
    ]
})

Vue.use(Router)